import type { GetPositionsRow } from '@morfi/backend-sdk-v2/client';
import { isNonNegativeI64, isU128 } from '@morfi/market-math';
import { D9_SCALE } from '@/config/solana';

/**
 * Average-entry chart reference. It is not an executable break-even or P&L
 * valuation. Derived from the fee-free basis — the one the P&L view marks the
 * open lot against — so the line sits where the P&L break-even is.
 */
export function averageEntryPriceD9(row: GetPositionsRow): bigint {
  const balanceD6 = integerWire(row.balance);
  const basisD6 = integerWire(row.costBasisD6);
  if (balanceD6 === null || basisD6 === null || balanceD6 === BigInt(0)) return BigInt(0);
  const numerator = basisD6 * BigInt(D9_SCALE);
  return isU128(numerator) ? numerator / balanceD6 : BigInt(0);
}

function integerWire(value: string | undefined): bigint | null {
  if (value === undefined || !/^\d+$/.test(value)) return null;
  const parsed = BigInt(value);
  return isNonNegativeI64(parsed) ? parsed : null;
}
